import Flickity from 'flickity';
import * as React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from "react-dom/client";

import createStore from '../configs/create-store-with-generators.js';

import * as CardReducer from '../modules/card/card.reducers.js';
import * as URLReducer from '../modules/url/url.reducers.js';
import * as BreadcrumbsReducer from '../modules/breadcrumbs/breadcrumbs.reducers.js';
import { user } from '../modules/user/user.reducers.js';
import * as UIReducer from '../modules/ui/ui.reducers.js';

import ErrorHandler from '../modules/error/error-handler.screen.js';
import IndexAirTourProScreen from '../modules/landing-page/index.ATPScreen.js';


const initialState = window.serverData.initialState;

const store = createStore(initialState, {
  user,
  ...CardReducer,
  ...BreadcrumbsReducer,
  ...UIReducer,
  ...URLReducer
});

const atpWrapperApp = (
  <Provider store={store}>
    <ErrorHandler>
      <div id="index-atp">
        <IndexAirTourProScreen/>
      </div>
    </ErrorHandler>
  </Provider>
);

const atpRootEl = document.getElementById('js--index-airtourpro');
if (atpRootEl) {
  atpRootEl.innerHTML = '';
  const root = createRoot(atpRootEl);
  root.render(atpWrapperApp);
}

window.addEventListener('load', function() {
  const indexManagementSlider = document.querySelector('.js--index-management-slider');
  const indexAllIncludeItems = document.querySelector('.js--index-all-include-items');

  let allIncludeItems;

  const defaultFlickityOptions = {
    cellAlign: 'center',
    imagesLoaded: true,
    percentPosition: true,
    dragThreshold: 50,
    draggable: true,
    pageDots: true,
  };

  const processSlider = () => {
    if (window.innerWidth < 769) {
      if (indexAllIncludeItems) {
        allIncludeItems = new Flickity(indexAllIncludeItems, {
          ...defaultFlickityOptions,
          wrapAround: true
        });
      }
    } else if (allIncludeItems && allIncludeItems.constructor.name === 'Flickity') {
      allIncludeItems.destroy();
    }
  };

  processSlider();
  addEventListener("resize", processSlider);

  if (indexManagementSlider) {
    new Flickity(indexManagementSlider, {
      ...defaultFlickityOptions,
      contain: true,
    });
  }

  require(['jquery', 'fotorama/fotorama.js'], $ => {
    if (!$('html').hasClass('touch')) {
      $('.fotorama').attr('data-swipe', 'false');
    }
  });
})